var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{ref:"mobile-only",staticClass:"sm-only"}),(_vm.isConfigLoaded)?[_c('div',{staticClass:"container"},[_c(_vm.layout,{tag:"component"})],1),(_vm.showMobile)?_c('footer-mobile'):_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }